export enum MessageType {
    InAppMessage = "InAppMessage",
    SmsMessage = "SmsMessage",
}

export interface Message {
    type: MessageType;
    displayDate: string;
    message: string;
    user: null | {
        name: string;
    };
}

export type Messages = Message[];

export interface MessageData {
    total: number;
    messages: Messages;
}
